//export const BASE_URL = 'https://www2.buy.am:3500/api/';
export const BASE_URL = '/api/';
//export const BASE_SOCKET_SERVER = 'https://www2.buy.am:3500/';
export const BASE_SOCKET_SERVER = '/';
export const LANG = 'hy';